import { render } from "./EsitiPrecheckSWO.vue?vue&type=template&id=63bfbbf7&scoped=true"
import script from "./EsitiPrecheckSWO.vue?vue&type=script&lang=js"
export * from "./EsitiPrecheckSWO.vue?vue&type=script&lang=js"

import "./EsitiPrecheckSWO.vue?vue&type=style&index=0&id=63bfbbf7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bfbbf7"]])

export default __exports__